import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import TickerBand from "./components/TickerBand";
import CollectionRail from "./components/CollectionRail";
import HotVideos from "./components/HotVideos";
import TopicWall from "./components/TopicWall";
import RankingBoard from "./components/RankingBoard";
import DownloadZone from "./components/DownloadZone";
import EditorPicks from "./components/EditorPicks";
import SubscribeBand from "./components/SubscribeBand";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 font-sans text-foreground-950">
      <TopNav />
      <main className="w-full max-w-[1440px] mx-auto">
        <Hero />
        <TickerBand />
        <CollectionRail />
        <HotVideos />
        <TopicWall />
        <RankingBoard />
        <DownloadZone />
        <EditorPicks />
        <SubscribeBand />
      </main>
      <SiteFooter />
    </div>
  );
}